export const getBorderVariantWithSource = (sourceLink: string) => {
  if (sourceLink?.includes('gold')) return 'borderGold';
  if (sourceLink?.includes('silver')) return 'borderSilver';
  if (sourceLink?.includes('bronze')) return 'borderBronze';
  if (sourceLink?.includes('halloween')) return 'borderHalloween';
  return 'borderDefault';
};
